import { getBeastIntegrationSubject } from '@common/abilities/beastIntegration';
import { AbilityCan } from '@common/enums';

import { useUserAbilities } from '~/contexts';

type BeastMaterialPermissions = {
    canRead: boolean;
    canCreate: boolean;
    canUpdate: boolean;
    canDelete: boolean;
};

export const useBeastMaterialPermissions = (): BeastMaterialPermissions => {
    const { user, ability } = useUserAbilities();

    return {
        canRead: ability.can(AbilityCan.READ, getBeastIntegrationSubject(user)),
        canCreate: ability.can(AbilityCan.CREATE, getBeastIntegrationSubject(user)),
        canUpdate: ability.can(AbilityCan.UPDATE, getBeastIntegrationSubject(user)),
        canDelete: ability.can(AbilityCan.DELETE, getBeastIntegrationSubject(user)),
    };
};
